// extracted by mini-css-extract-plugin
module.exports = {"filter":"filter-module--filter--29Ogo","footer":"filter-module--footer--18sGX","advice":"filter-module--advice--TprIQ","show":"filter-module--show--21N8X"};